<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="$t('Please wait')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/manage' }"
          >商务&销售管理</el-breadcrumb-item
        > -->
        <el-breadcrumb-item
          :to="{ path: '/comSelectMsgIndex/cSelectMsgList' }"
          >{{ $t("Add example") }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $t("Add/edit example") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block input_block flex-rowl">
            <span>{{ $t("Product name") }}</span>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname"
                :placeholder="$t('Enter Product Name')"
                v-if="COUNTRY.countryid == 1"
              ></el-input>
              <el-input
                v-model="formData.commodityname_e"
                :placeholder="$t('Enter Product Name')"
                v-else-if="COUNTRY.countryid == 8"
              ></el-input>
              <el-input
                v-model="formData.commodityname_m"
                :placeholder="$t('Enter Product Name')"
                v-else-if="COUNTRY.countryid == 2"
              ></el-input>
              <el-input
                v-model="formData.commodityname_y"
                :placeholder="$t('Enter Product Name')"
                v-else-if="COUNTRY.countryid == 4"
              ></el-input>
            </div>
            <span
              class="copy_box"
              :data-clipboard-text="
                COUNTRY.countryid == 1
                  ? formData.commodityname
                  : COUNTRY.countryid == 8
                  ? formData.commodityname_e
                  : COUNTRY.countryid == 2
                  ? formData.commodityname_m
                  : formData.commodityname_y
              "
              @click="handleCopyBtn"
              ><i class="iconfont icon-fuzhi"></i
            ></span>
          </div>
          <div class="block">
            <p><span class="mark">*</span>{{ $t("Upload Screenshot") }}：</p>
            <div class="upload_list flex-rowl">
              <div
                class="upload_box"
                v-for="(item, index) in picsList"
                :key="index"
                @mouseenter="enter(index)"
                @mouseleave="creenIndex = ''"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                >
                  <div v-if="item">
                    <img :src="item" class="avatar" />
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex === index"
                    >
                      <span @click.stop="handlePictureCardPreview(item)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="handleRemove(index)"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="upload_box custom_upload" v-if="picsList.length < 6">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  @change="handleFileChange"
                />
              </div>
            </div>
          </div>
          <div class="block shop_label_wrap">
            <p class="b"><span class="mark">*</span>{{ $t("Product type") }}</p>
            <!-- <div class="radio_box">
              <p>请选择一级分类</p>
              <el-radio-group
                v-model="formData.labelid"
                @change="handleChangeLabel1($event, true)"
              >
                <el-radio
                  v-for="item in labelChilds1"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.labelname_y ? item.labelname_y : item.labelname }}</el-radio
                >
              </el-radio-group>
            </div> -->
            <div class="radio_box" v-if="labelChilds2.length > 0">
              <p>{{ $t("Secondary classification") }}</p>
              <el-radio-group
                v-model="formData.labelid2"
                @change="handleChangeLabel2($event, true)"
              >
                <el-radio
                  v-for="item in labelChilds2"
                  :key="item.id"
                  :label="item.id"
                  >{{
                    item.multilingualName
                  }}</el-radio
                >
              </el-radio-group>
            </div>
            <div class="radio_box" v-if="labelChilds3.length > 0">
              <p>{{ $t("Tertiary classification") }}</p>
              <el-radio-group v-model="formData.labelid3">
                <el-radio
                  v-for="item in labelChilds3"
                  :key="item.id"
                  :label="item.id"
                  >{{
                    item.multilingualName
                  }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>{{ $t("Order source channel") }}：</p>
            <div class="radio_box" style="margin: 25px auto 15px">
              <el-radio-group v-model="formData.channel">
                <el-radio
                  v-for="(item, index) in channelList"
                  :key="index"
                  :label="item.channeldesc"
                  >{{ item.channeldesc }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p>{{ $t("Seller ID") }}</p>
            <div class="input_box">
              <el-input
                v-model="formData.sellerid"
                :placeholder="$t('Seller ID')"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>{{ $t("Price Range") }}</p>
            <div class="flex-between">
              <div class="block_wrap">
                <div class="input_box">
                  <el-input
                    v-model="formData.pricemin"
                    placeholder=""
                  ></el-input>
                </div>
              </div>
              <span>/</span>
              <div class="block_wrap">
                <div class="input_box">
                  <el-input
                    v-model="formData.pricemax"
                    placeholder=""
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="block flex-between">
            <div class="block_wrap">
              <p>{{ $t("Evaluation") }}</p>
              <div class="input_box">
                <el-input v-model="formData.sellnum" placeholder=""></el-input>
              </div>
            </div>
            <div class="block_wrap">
              <p>{{ $t("Volume") }}</p>
              <div class="input_box">
                <el-input v-model="formData.goodtalk" placeholder=""></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="handleSubmit">{{ $t("Confirm") }}</div>
      <div class="return_txt" @click="handleReturn">←{{ $t("Return") }}</div>
    </div>
    <!--  主要内容 end -->

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import {
  encryptstringview,
  uploadImage,
  getCommondityLabel,
} from "../../api/api";
import {
  getOrderChannelList,
  getShopSelectMsgDetail,
  addShopSelectMsg,
  editShopSelectMsg,
} from "../../api/shop";
import { calculator } from "../../utils/decimal";
import { mapState } from "vuex";
import Clipboard from "clipboard";
export default {
  name: "cSelectMsgEdit",
  data() {
    return {
      id: "",
      loading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      creenIndex: "",
      channelList: [], // 订单来源
      formData: {
        id: "",
        commodityname: "",
        commodityname_e: "",
        commodityname_y: "",
        commodityname_m: "",
        commodityname_t: "",
        commodityname_r: "",
        commodityname_l: "",
        channel: "",
        pic: "",
        pic2: "",
        pic3: "",
        pic4: "",
        pic5: "",
        exrate: 1,
        pricemin: "",
        pricemax: "",
        sellerid: "",
        goodtalk: "",
        sellnum: "",
        specialopenid: "",
        labelid: "f23677a3e21742ba8ef11c3b1ea761ab",
        labelid2: "",
        labelid3: "",
        countryids: "",
      },
      picsList: [], // 订单信息截图凭证
      allLabel: [],
      labelChilds1: [],
      labelChilds2: [],
      labelChilds3: [],
    };
  },
  filters: {
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) return;
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "USERINFO", "COUNTRY"]),
  },
  created() {
    this.formData.countryids = this.COUNTRY.countryid;

    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    this.getOrderChannelList();
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },

  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.getShopLabel();
        if (id) {
          this.getShopSelectMsgDetail();
        }
      } else {
        this.$router.back();
      }
    },

    handleMultilingualName(dataList, key1, key2, key3, key4) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        if (countryid == 1) {
          v.multilingualName = v[key1];
        } else if (countryid == 8) {
          // 英文
          v.multilingualName = v[key2] ? v[key2] : v[key1];
        } else if (countryid == 2) {
          // 俄语
          v.multilingualName = v[key3] ? v[key3] : v[key2] ? v[key2] : v[key1];
        } else if (countryid == 4) {
          // 越语
          v.multilingualName = v[key4] ? v[key4] : v[key2] ? v[key2] : v[key1];
        }
      });
      return dataList;
    },

    // 获取订单来源
    getOrderChannelList() {
      getOrderChannelList().then((res) => {
        let newRes = res.list.filter((v) => v.isusestr == "是");
        //
        let filter = newRes.filter(
          (v) =>
            v.channel == "TikTok" ||
            v.channel == "Temu" ||
            v.channel == "Wildberries" ||
            v.channel == "Partner's Offline Stores/Shop" ||
            v.channel == "OZON" ||
            v.channel == "Partner Independent Website" ||
            v.channel == "Partner Independent APP" ||
            v.channel == "Telegram" ||
            v.channel == "VK" ||
            v.channel == "Yandex Market" ||
            v.channel == "Others" ||
            v.channel == "Instagram"
        );
        this.channelList = filter;
      });
    },

    // 商品详情
    getShopSelectMsgDetail() {
      getShopSelectMsgDetail({ id: this.formData.id }).then((res) => {
        // let newPicList = [];
        // if (res.pic) {
        //   newPicList.push(res.pic);
        // }
        // if (res.pic2) {
        //   newPicList.push(res.pic2);
        // }
        // if (res.pic3) {
        //   newPicList.push(res.pic3);
        // }
        // if (res.pic4) {
        //   newPicList.push(res.pic4);
        // }
        // if (res.pic5) {
        //   newPicList.push(res.pic5);
        // }
        const filteredArr = Object.keys(res)
          .filter((key) => key.startsWith("pic"))
          .map((key) => res[key]);
        this.picsList = filteredArr.filter(
          (item) => item !== null && item !== undefined && item !== ""
        );
        this.formData.commodityname = res.commodityname
          ? res.commodityname
          : "";
        this.formData.commodityname_e = res.commodityname_e
          ? res.commodityname_e
          : "";
        this.formData.commodityname_y = res.commodityname_y
          ? res.commodityname_y
          : "";
        this.formData.commodityname_m = res.commodityname_m
          ? res.commodityname_m
          : "";
        this.formData.commodityname_t = res.commodityname_t
          ? res.commodityname_t
          : "";
        this.formData.commodityname_r = res.commodityname_r
          ? res.commodityname_r
          : "";
        this.formData.commodityname_l = res.commodityname_l
          ? res.commodityname_l
          : "";
        this.formData.channel = res.channel;
        // this.formData.pic = res.pic;
        // this.formData.pic2 = res.pic2;
        // this.formData.pic3 = res.pic3;
        // this.formData.pic4 = res.pic4;
        // this.formData.pic5 = res.pic5;
        this.formData.exrate = res.exrate;
        this.formData.pricemin = res.pricemin;
        this.formData.pricemax = res.pricemax;
        this.formData.sellerid = res.sellerid;
        this.formData.goodtalk = res.goodtalk;
        this.formData.sellnum = res.sellnum;
        this.formData.labelid2 = res.labelid2;
        this.formData.labelid3 = res.labelid3;
      });
    },

    // 获取商品分类标签
    getShopLabel() {
      getCommondityLabel().then((res) => {
        let filter = res
          .filter((v) => v.labelstate == 1)
          .sort((a, b) => a.sort - b.sort);
        this.allLabel = filter;
        this.labelChilds1 = filter;
        filter.forEach((v) => {
          if (v.id == "f23677a3e21742ba8ef11c3b1ea761ab") {
            // 不同国家选择多语言
            let MultilingualArr = this.handleMultilingualName(
              v.childs2,
              "labelname",
              "labelname_e",
              "labelname_m",
              "labelname_y"
            );
            this.labelChilds2 = MultilingualArr.filter(
              (v) => v.labelstate == 1
            ).sort((a, b) => a.sort - b.sort);
          }
        });
        // this.getDetail();
      });
    },
    // 触发一级分类，获取二级数据
    handleChangeLabel1(e, isClick) {
      let { allLabel } = this;
      let labelChilds2 = [];
      allLabel.forEach((v) => {
        if (v.id == e) {
          labelChilds2 = v.childs2;
        }
      });
      this.labelChilds2 = labelChilds2
        .filter((item) => item.labelstate === "1")
        .sort((a, b) => a.sort - b.sort);
      if (isClick) {
        this.labelChilds3 = [];
        this.formData.labelid2 = "";
        this.formData.labelid3 = "";
      }
    },
    // 触发二级分类，获取三级数据
    handleChangeLabel2(e, isClick) {
      let { labelChilds2 } = this;
      let labelChilds3 = [];
      labelChilds2.forEach((v) => {
        if (v.id == e) {
          let MultilingualArr = this.handleMultilingualName(
            v.childs3,
            "labelname",
            "labelname_e",
            "labelname_m",
            "labelname_y"
          );
          labelChilds3 = MultilingualArr.filter((v) => v.labelstate == 1).sort(
            (a, b) => a.sort - b.sort
          );
        }
      });
      this.labelChilds3 = labelChilds3
        .filter((item) => item.labelstate === "1")
        .sort((a, b) => a.sort - b.sort);
      if (isClick) {
        this.formData.labelid3 = "";
      }
    },

    // 大图预览
    handlePictureCardPreview(item) {
      this.dialogImageUrl = item;
      this.dialogVisible = true;
    },
    // 移除图片
    handleRemove(index) {
      let { picsList } = this;
      picsList.splice(index, 1);
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error(this.$t("Thumbnails can only be images"));
      }
    },
    handleFileChange(event) {
      this.uploadImgIndex = 0;
      const files = event.target.files;

      // 递归调用上传图片方法
      this.uploadImages(files, 0);
    },
    uploadImages(files) {
      if (this.uploadImgIndex < files.length) {
        const file = files[this.uploadImgIndex];

        if (file && file.size <= 2 * 1024 * 1024) {
          // 限制文件大小为2M内
          const formData = new FormData();
          formData.append("image", file, file.name);

          uploadImage(formData).then((res) => {
            if (this.picsList.length < 6) {
              // 限制最多只能上传六张图片
              this.insertImageInfo(res.url, this.uploadImgIndex);

              // 递归调用上传下一张图片
              this.uploadImgIndex += 1;
              this.uploadImages(files);
            } else {
              this.$message(this.$t("Maximum upload limit of 10 pictures"));
            }
          });
        } else {
          this.$message(
            this.$t("Please select image files that are no larger than 2M")
          );
        }
      }
    },
    insertImageInfo(imageInfo) {
      this.$set(this.picsList, this.picsList.length, imageInfo); // 根据索引插入图片信息
    },

    beforeAvatarUpload(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          this.picsList.push(res.url);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
      // 返回 false 阻止自动上传
      return false;
    },

    // 防抖函数
    debouncedChange(newPrice, value) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.priceReal = calculator(newPrice).divide(Number(value)).toNumber();
      }, 500); // 设置延迟时间，单位为毫秒
    },

    // 提交数据
    handleSubmit() {
      let { formData, OPENID, picsList } = this;
      if (formData.commodityname_y == "") {
        this.$message.warning(this.$t("Enter Product Name"));
        return;
      }
      if (formData.channel == "") {
        this.$message.warning(this.$t("Order source channel"));
        return;
      }
      if (picsList.length == 0) {
        this.$message.warning("Tải ảnh chụp màn hình lên！");
        return;
      }
      this.formData.specialopenid = OPENID;
      let newFormData = picsList.reduce((acc, url, index) => {
        if (index > 0) {
          acc[`pic${index + 1}`] = url;
        } else {
          acc[`pic`] = url;
        }
        return acc;
      }, {});

      this.loading = true;
      this.formData = { ...this.formData, ...newFormData };
      if (formData.id) {
        editShopSelectMsg(this.formData).then((res) => {
          let data = res;
          if (data.result) {
            this.$message.success(
              this.$t("Addition successful (operation successful)")
            );
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(this.$t("Server Error"));
          }
        });
      } else {
        addShopSelectMsg(this.formData).then((res) => {
          let data = res;
          if (data.result) {
            this.$message.success(
              this.$t("Addition successful (operation successful)")
            );
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(this.$t("Server Error"));
          }
        });
      }
      //   addLsOrder(this.formData).then((res) => {
      //     if (res.result) {
      //       let message = this.$message.success(res.message);
      //       message.close();
      //       setTimeout(() => {
      //         this.loading = false;
      //         this.$router.back();
      //       }, 500);
      //     } else {
      //       this.loading = false;
      //       this.$message.error(res.message || "服务器报错，请稍后～");
      //     }
      //   });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    height: 68vh;
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
        .red {
          font-size: 14px;
          color: red;
        }
        .input_box {
          margin-bottom: 0;
        }
        .input_block {
          .input_box {
            flex: 1;
            margin: 0 10px 0 20px;
          }
        }
        .block_wrap {
          width: 42%;
        }
        .shop_label_wrap {
          .radio_box {
            margin-bottom: 20px;
            p {
              font-size: 12px;
              margin-bottom: 10px;
            }
          }
        }
      }
      .shop_wrap {
        flex: 1;
        font-size: 16px;
        .shop_list_wrap {
          .shop_item {
            margin-bottom: 20px;
            border-bottom: 1px solid #ccc;
          }
          .txt {
          }
          .label {
            color: #969696;
            margin: 10px 0 20px;
          }
          .price_group {
            font-size: 14px;
            p {
              margin-bottom: 5px;
            }
          }
          .operation_wrap {
            margin-top: 10px;
            .operate_btn {
              border-radius: 20px;
              border: 1px solid #dcdfe6;
              font-size: 14px;
              margin-right: 10px;
              padding: 5px 10px;
              cursor: pointer;
              .icon-gengduo1 {
                font-size: 14px;
                margin-left: 10px;
              }
              .icon-dangeyichuicon {
                font-size: 12px;
                margin-left: 10px;
              }
            }
          }
        }

        /deep/ .el-empty {
          padding: 0;
        }
        /deep/ .el-empty__image {
          width: 100px;
        }
      }
      .add_btn {
        height: 50px;
        border: 1px solid #dcdfe6;
        // background: #fff;
        cursor: pointer;
        margin-top: 30px;
        .icon-components {
          margin-right: 10px;
          font-size: 18px;
          color: #515151;
        }
      }
      .upload_list {
        flex-wrap: wrap;
        .upload_box {
          margin-right: 20px;
          margin-bottom: 20px;
          &:last-child {
            margin-right: 0;
          }
        }
        .custom_upload {
          background-color: #fbfdff;
          border: 1px dashed #c0ccda;
          border-radius: 6px;
          box-sizing: border-box;
          width: 148px;
          height: 148px;
          cursor: pointer;
          line-height: 146px;
          vertical-align: top;
          cursor: pointer;
          input {
            opacity: 0;
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 10;
            cursor: pointer;
          }
          .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            z-index: 9;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
</style>